import { render, staticRenderFns } from "./EventsComponent.vue?vue&type=template&id=53dedd80&scoped=true"
import script from "./EventsComponent.vue?vue&type=script&lang=js"
export * from "./EventsComponent.vue?vue&type=script&lang=js"
import style0 from "./EventsComponent.vue?vue&type=style&index=0&id=53dedd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dedd80",
  null
  
)

export default component.exports